import { fetchData } from '@/utils/fetch'

export const retrieveProductList = (data) => {
  return fetchData('/dsp-app/alibaba-common/searchKeyWord?itemNumber=50', {
    method: 'post',
    body: JSON.stringify(data)
  })
}
